import Button from "../button/Button";
import {Dialog, DialogActions, DialogContent, DialogTitle} from "@dain/mui-components";
import {ReactNode} from "react";

export interface DialogButtonProps {
    onClick: () => void;
    title: string;
}

export interface InformationDialogProps {
    open: boolean;
    onClose: () => void;
    title: string;
    primaryButton?: DialogButtonProps;
    secondaryButton?: DialogButtonProps;
    children: ReactNode;
}

export default function InformationDialog(props: InformationDialogProps) {
    const {children, open, onClose, title, primaryButton, secondaryButton} = props;

    return (
        <Dialog open={open} onClose={onClose}>
            <DialogTitle title={title} />
            <DialogContent>
                {children}
            </DialogContent>
            <DialogActions>
                {secondaryButton !== undefined &&
                    <Button variant={"secondary"}
                            onClick={secondaryButton.onClick}>
                        {secondaryButton.title}
                    </Button>
                }
                {primaryButton !== undefined &&
                    <Button variant={"primary"}
                            onClick={primaryButton.onClick}>
                        {primaryButton.title}
                    </Button>
                }
            </DialogActions>
        </Dialog>
    );

}
